<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<mat-card class="branding--title-card">
		<mat-card-content>
			<div class="title-card">
				<h1>
					{{ "PROFILE.MAIN_PAGE_TITLE" | translate }}
				</h1>
			</div>
		</mat-card-content>
	</mat-card>

	<mat-card class="branding--section-card">
		<mat-card-content>
			<div class="fields-container">
				<div class="field">
					<div class="data-panel-field-label">{{ "PROFILE.FIELD_LABEL_NAME" | translate }}</div>
					<div class="data-panel-field-value">{{ userName }}</div>
				</div>
				<div class="field">
					<div class="data-panel-field-label">{{ "PROFILE.FIELD_LABEL_EMAIL" | translate }}</div>
					<div class="data-panel-field-value">{{ userEmail }}</div>
				</div>

			</div>
		</mat-card-content>
	</mat-card>

	<mat-card class="branding--section-card" *ngIf="isChangePasswordPanelShown">
		<mat-card-content>
			<h2>{{ "PROFILE.SECTION_TITLE_CHANGE_PASSWORD" | translate }}</h2>
			<form [formGroup]="changePasswordForm" class="change-password-form" (ngSubmit)="submitPasswordChange()">
				<mat-form-field>
					<mat-label>{{ "PROFILE.FIELD_LABEL_NEW_PASSWORD" | translate }}</mat-label>
					<input matInput type="{{ isPasswordShown ? 'text' : 'password' }}" required formControlName="newPassword" id="new-password" name="new-password" autocomplete="new-password">
					<button mat-icon-button matSuffix type="button" (click)="isPasswordShown = !isPasswordShown">
						<mat-icon>{{ isPasswordShown ? 'visibility_off' : 'visibility' }}</mat-icon>
					</button>
					<mat-error [cassErrorForFormControl]="newPasswordControl"></mat-error>
				</mat-form-field>
				<mat-form-field>
					<mat-label>{{ "PROFILE.FIELD_LABEL_CONFIRM_NEW_PASSWORD" | translate }}</mat-label>
					<input matInput type="{{ isPasswordShown ? 'text' : 'password' }}" required formControlName="confirmPassword" (keydown.enter)="changePasswordForm.valid && submitPasswordChange()" id="confirm-password" name="confirm-password" autocomplete="new-password">
					<button mat-icon-button matSuffix type="button" (click)="isPasswordShown = !isPasswordShown">
						<mat-icon>{{ isPasswordShown ? 'visibility_off' : 'visibility' }}</mat-icon>
					</button>
					<mat-error [cassErrorForFormControl]="confirmPasswordControl"></mat-error>
				</mat-form-field>
			</form>
			<div class="order-lines-action-buttons-container button-container">
				<button mat-stroked-button [disabled]="!changePasswordForm.valid" (click)="submitPasswordChange()">{{ "PROFILE.ACTION_SUBMIT_PASSWORD" | translate }}</button>
				<button mat-stroked-button (click)="cancelPasswordChange()">{{ "PROFILE.ACTION_CANCEL_PASSWORD" | translate }}</button>
			</div>
		</mat-card-content>
	</mat-card>

	<mat-card class="branding--action-card button-container">
		<mat-card-content>
			<button mat-stroked-button [disabled]="isChangePasswordPanelShown" (click)="displayChangePasswordPanel()">{{ "PROFILE.ACTION_CHANGE_PASSWORD" | translate }}</button>
		</mat-card-content>
	</mat-card>
</div>
